const PRODUCT = {
  TYPES: {
    FRAME: 'frame',
    SUNGALSSES: 'sungalsses',
    LENS_L: 'lens_l',
    LENS_R: 'lens_r',
    CONTACT_LENS_L: 'contact_lens_l',
    CONTACT_LENS_R: 'contact_lens_r',
    LENS: 'lens',
  },
}

export default PRODUCT
